import { GithubContributorsPreview } from 'app/(public)/components/github-contributors-preview.tsx';

Pillage First! is **proudly open-source** and released under the AGPL-3.0 license. We believe that **openness**,
**collaboration**,and **transparency** produce **better software** and **richer player experiences**. The entire
codebase is therefore available for study, contributions, or to serve as the foundation for your own project.
<br />
**Pillage First! grows through code, feedback, testing and ideas from the community.**
<br />
<div className="grid gap-2 grid-cols-8 w-fit">
  <GithubContributorsPreview />
</div>
<br />
**Like the project? Give us a star!**
